var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCss(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6379 106.99L8.21228 1.26709H111.787L102.352 106.974L59.937 118.733L17.6379 106.99V106.99Z",
    fill: "#1572B6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0009 109.746L94.275 100.243L102.338 9.9115H60.0009V109.746Z",
    fill: "#33A9DC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0009 48.2143H77.159L78.344 34.9365H60.0009V21.9699H92.5153L92.204 25.449L89.0165 61.1809H60.0009V48.2143Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0778 81.8895L60.0206 81.9063L45.5803 78.0073L44.6568 67.6657H31.6425L33.4584 88.0254L60.0187 95.397L60.0778 95.3801V81.8895V81.8895Z",
    fill: "#EBEBEB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M76.0566 60.6328L74.4947 77.9972L60.0328 81.9009V95.3916L86.6147 88.0247L86.8097 85.8337L89.0653 60.6328H76.0566Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0448 21.9699V34.9365H28.7248L28.4651 32.0227L27.8745 25.449L27.5642 21.9699H60.0448V21.9699ZM60.0008 48.2162V61.1827H45.7423L45.4826 58.269L44.8911 51.6952L44.5817 48.2162H60.0008V48.2162Z",
    fill: "#EBEBEB"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCss);
export default __webpack_public_path__ + "static/media/css.be5eea00080e655c6cf3d4b6b7cca7da.svg";
export { ForwardRef as ReactComponent };